var React = require('react');

function XIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.07514 0C0.799916 0 0.524978 0.105256 0.314978 0.315226C-0.104993 0.735207 -0.104993 1.4166 0.314978 1.83658L4.49767 6.01875L0.315495 10.2009C-0.104505 10.6209 -0.104505 11.3018 0.315495 11.7218C0.735465 12.1417 1.41687 12.1417 1.83685 11.7218L6.01851 7.53959L10.2007 11.7218C10.6207 12.1417 11.3015 12.1417 11.7215 11.7218C12.1415 11.3018 12.1415 10.6209 11.7215 10.2009L7.53934 6.01875L11.722 1.83658C12.142 1.4166 12.142 0.735207 11.722 0.315226C11.512 0.105256 11.2366 0 10.9614 0C10.6861 0 10.3971 0.0915898 10.2017 0.315226L6.01851 4.49843L1.83582 0.315226C1.62581 0.105256 1.35036 0 1.07514 0Z","fill":"#a83838"}));
}

XIconInline.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none"};

module.exports = XIconInline;

XIconInline.default = XIconInline;
